import { Gutter } from 'antd/lib/grid/row';
import { FormType } from 'enums/FieldTypeEnums';

export const CATEGORY6CONSTANTS = {
  LABELS: {
    // Distance-based travel fields
    TRAVEL_MODE: 'Travel Mode',
    ORIGIN: 'Origin',
    DESTINATION: 'Destination',
    ROUND_TRIP: 'Round Trip',
    NUMBER_OF_PASSENGERS: 'Number of Passengers',
    CAR_SIZE: 'Car Size',
    CAR_TYPE: 'Car Type',
    FLIGHT_CLASS: 'Flight Class',

    // Spend-based travel fields
    SPEND_TYPE: 'Spend Type',
    MONEY: 'Amount',
    MONEY_UNIT: 'Currency',
    SPEND_LOCATION: 'Spend Location',

    // Hotel stay fields
    HOTEL_NIGHTS: 'Number of Nights Stayed',
    LOCATION: 'Hotel Location',
  },

  // Field names for distance-based travel
  FIELD_TRAVEL_MODE: 'travelMode',
  FIELD_ORIGIN: 'origin',
  FIELD_DESTINATION: 'destination',
  FIELD_ROUND_TRIP: 'roundTrip',
  FIELD_NUMBER_OF_PASSENGERS: 'numberOfPassengers',
  FIELD_CAR_SIZE: 'carSize',
  FIELD_CAR_TYPE: 'carType',
  FIELD_FLIGHT_CLASS: 'flightClass',

  // Field names for spend-based travel
  FIELD_SPEND_TYPE: 'spendType',
  FIELD_MONEY: 'money',
  FIELD_MONEY_UNIT: 'moneyUnit',
  FIELD_SPEND_LOCATION: 'spendLocation',

  // Field names for hotel stays
  FIELD_HOTEL_NIGHTS: 'hotelNights',
  FIELD_LOCATION: 'location',

  rowGutter: [16, 16] as Gutter,
  formType: FormType.REACT_HOOK_FORMS,
};

// Travel mode options for distance-based travel
export const travelModeOptions = [
  { value: 'air', label: 'Air' },
  { value: 'car', label: 'Car' },
  { value: 'rail', label: 'Rail' },
];

// Spend type options for spend-based travel
export const spendTypeOptions = [
  { value: 'air', label: 'Air Travel' },
  { value: 'road', label: 'Road Travel' },
  { value: 'rail', label: 'Rail Travel' },
  { value: 'sea', label: 'Sea Travel' },
  { value: 'hotel', label: 'Hotel' },
];

// Car size options
export const carSizeOptions = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
  { value: 'average', label: 'Average' },
];

// Car type options
export const carTypeOptions = [
  { value: 'petrol', label: 'Petrol' },
  { value: 'diesel', label: 'Diesel' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'plugin_hybrid', label: 'Plugin Hybrid' },
  { value: 'battery', label: 'Battery Electric' },
  { value: 'average', label: 'Average' },
];

// Flight class options
export const flightClassOptions = [
  { value: 'economy', label: 'Economy' },
  { value: 'premium_economy', label: 'Premium Economy' },
  { value: 'business', label: 'Business' },
  { value: 'first', label: 'First Class' },
  { value: 'average', label: 'Average' },
];

// Currency options (lowercase to match API specification)
export const currencyOptions = [
  { value: 'usd', label: 'USD ($)' },
  { value: 'eur', label: 'EUR (€)' },
  { value: 'cad', label: 'CAD ($)' },
];

